import { Component, EventEmitter, inject, OnDestroy, OnInit, Output, signal } from '@angular/core';
import { HlmCardImports } from '@spartan-ng/helm/card';
import { HlmFieldImports } from '@spartan-ng/helm/field';
import { HlmInputImports } from '@spartan-ng/helm/input';
import { HlmSelectImports } from '@spartan-ng/helm/select';
import { HlmSpinnerImports } from '@spartan-ng/helm/spinner';
import { HlmButtonImports } from '@spartan-ng/helm/button';

import { FormBuilder, FormGroup, FormsModule, Validators, ReactiveFormsModule } from '@angular/forms';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { CommonModule } from '@angular/common';
import { lucideCreditCard, lucideInfo, lucideLockKeyhole } from '@ng-icons/lucide';
import { Api } from '../../../services/api';
import { NotificationService } from '../../../services/notification-service';
import { SessionService } from '../../../services/session-service';
import { NetworkOptions, itemToString} from '../../../constants/shared-variables';
import { environment } from '../../../../environments/environment';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';


@Component({
  selector: 'app-payment-form-step',
   imports: [NgIcon, CommonModule, FormsModule, ReactiveFormsModule, HlmButtonImports,HlmSpinnerImports, HlmSelectImports,HlmCardImports,HlmFieldImports,HlmInputImports],
  templateUrl: './payment-form-step.html',
  styleUrl: './payment-form-step.css',
  providers: [provideIcons({ lucideLockKeyhole, lucideInfo, lucideCreditCard })]
})
export class PaymentFormStep implements OnInit,OnDestroy {

  private fb = inject(FormBuilder);
  // private globalService = inject(GlobalService);
  // private readonly dialogService = inject(HlmDialogService);
  public sessionService = inject(SessionService);
  private apiService = inject(Api);
  private notificationService = inject(NotificationService);

  @Output() onContinue = new EventEmitter<any>

  networkList = NetworkOptions
  public readonly itemToStringNetworkList = (value: string) => this.networkList.find((item) => item.value === value)?.label || '';



  paymentForm:FormGroup = this.fb.group({
    serial_number: ['',[Validators.required]],
    payment_number: ['', [Validators.required, Validators.pattern('^0\\d{9}$')]],
    network: ['',[Validators.required]]
  })

  isPaymentLoading = signal(false);


  ngOnInit(): void {
    this.paymentForm.patchValue({serial_number: this.sessionService.formSubData()?.user?.serial_number})

  }

  ngOnDestroy(): void {
    // clear any timers when the component is destroyed to avoid leaks
    this.paymentForm.patchValue({serial_number: null})
  }

  getErrorMessagePayment(fieldName: string): string {
    const control = this.paymentForm.get(fieldName);

    if (!control || !control.errors) return '';

    if (control.errors['required'] || control.errors['requiredTrue']) {
      // Handles both standard required and requiredTrue (for checkboxes)
      if (fieldName === 'serial_number') {
        return 'No Serial Number Found';
      }
      return 'This field is required';
    }
    if (control.errors['email']) {
      return 'Please enter a valid email address';
    }
    if (control.errors['pattern']) {
      if (fieldName.toLowerCase().includes('phone')) {
        return 'Please enter a valid phone number (10 digits starting with 0)';
      }
      return 'Invalid format';
    }

    return 'Invalid input';
  }

  async onPaymentSubmit(){
    // this.paymentForm.patchValue({serial_number: this.sessionService.formSubData()?.user?.serial_number})
    console.log(this.paymentForm.value)
    if (this.paymentForm.invalid) {
      Object.keys(this.paymentForm.controls).forEach(key => {
        const control = this.paymentForm.get(key);
        control?.markAsTouched();
      });
      return;
    }

    this.isPaymentLoading.set(true)
    this.sendPaymentData(this.paymentForm.value).finally(()=> this.isPaymentLoading.set(false))
  }

  async sendPaymentData(data:any){
    console.log(data)
    // return
    return new Promise<boolean>((resolve, reject) => {
      this.apiService.postData(data, environment.submitPayment).subscribe({
      next: (response: HttpResponse<any>) => {
        // this.isLoading.set(false);
        if (response.status === 200 || response.status === 201) {
          console.log('response body', response.body);

          if(response.body?.status === 'success'){
            this.onContinue.emit(true)
            // this.onNext()
            // this.startPaymentStatusCheck()
            this.notificationService.notify(response.body?.message,'success',{duration:3000,position:'top-right'} );
          }else{
            this.notificationService.notify(response.body?.message,'warning',{duration:3000,position:'bottom-right'} );
          }
          resolve(true)

        }
       },
      error: (err: HttpErrorResponse) => {
        console.log('error error', err.error);
        resolve(false)
        const errorMessage = (err.error && err.error.message) ? err.error.message : 'Something went wrong';
        this.notificationService.notify(errorMessage,'error',{duration:3000} );
      }
    });
    })
  }
}
